<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">
                <v-ons-toolbar-button v-on:click="sidebarToggle" data-test-id="btn-sidebar">
                    <i class="fal fa-bars"></i>
                </v-ons-toolbar-button>
            </div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right" v-show="browse_only == false">
                <v-ons-toolbar-button>
                    <router-link v-if="user == null" v-bind:to="{ name: 'Login' }" v-bind:title="'Login'"
                                data-test-id="href-login">
                        <i class="fal fa-user"></i>
                    </router-link>
                    <router-link v-else v-bind:to="{ name: 'User' }" v-bind:title="'My account'" data-test-id="href-account">
                        <i class="fal fa-user"></i>
                    </router-link>
                </v-ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content main-background" v-bind:class="{ 'main-background': !outlets, 'mobile': outlets, 'full': !outlets}">
           
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <template v-if="outlets == null">
                <picture v-if="load_image">
                    <source media="(max-width: 420px)" srcset="/front-alt-420.png"/>
                    <source media="(max-width: 1024px)" srcset="/front-alt-2048.jpg"/>
                    <img src="/front-alt.jpg" class="front-image">
                </picture>
            </template>

            <template v-if="outlets">
                <div class="content-inner">
                    <v-ons-list class="mt-50">
                        <v-ons-list-item class="main-header" v-if="outlets && outlets.length == 0">
                            No outlets found near {{ location_string }}
                        </v-ons-list-item>
                        <v-ons-list-item class="main-header" v-if="outlets && outlets.length > 0">
                            Discover new tasting experiences
                        </v-ons-list-item>
                        <v-ons-list-item class="regular-text">
                            <template v-if="outlets.length == filtered_outlets.length">
                                Showing {{ outlets.length }} stores near {{ location_string }}
                            </template>
                            <template v-else>
                                Showing {{ filtered_outlets.length }} of {{ outlets.length }} stores near {{ location_string }}
                            </template>

                            <a v-on:click="searchAgain" class="active-text ml-10 pressable">Change</a>
                        </v-ons-list-item>
                        <v-ons-search-input
                                v-show="outlets.length > 0"
                                placeholder="Search for a store, cuisine or tag"
                                v-model="outlet_query"/>
                    </v-ons-list>

                    <v-ons-list data-test-id="cnt-outlets">
                        <outlet-list-item v-for="outlet in filtered_outlets"
                                          v-bind:outlet="outlet"
                                          v-bind:show_distance="true"
                                          v-bind:key="outlet.id"/>
                    </v-ons-list>
                </div>
            </template>

            <section v-if="!outlets" class="section-vh big-button-container bottom-button-container">

                <div>Welcome to Goodeats</div>

                <div class="main-header">Find a place close to home for collection or delivery</div>

                <gtc-button class="btn-action"
                            v-show="show_search_gps"
                            icon="fal fa-location-arrow"
                            v-on:click="getOutletsGPS"
                            data-test-id="btn-search-gps">
                    Search by your location
                </gtc-button>

                <gtc-button class="secondary"
                            icon="fal fa-map-marker-check"
                            v-on:click="getOutletsPostcode"
                            data-test-id="btn-search-postcode">
                    {{ postcode_search_label }}
                </gtc-button>

            </section>
        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as OutletListItem } from '../fragments/outlet_list_item'

    export default {

        components: {
            'outlet-list-item': OutletListItem,
        },

        created() {

        },

        mounted() {

            if (this.isOwnPage())
                this.load_image = true
        },

        data () {
            return {
                app: this.$root.$data.app,
                outlets: null,
                loading: false,
                search_method: null,
                postcode: '',
                outlet_query: '',
                location_access_granted: false,
                load_image: false,
            }
        },

        methods: {

            ...mapMutations([
                'setLocation',
                'setSidebarOpen',
            ]),

            canUseGPS(){
                return 'geolocation' in navigator &&
                    (document.location.protocol == 'https:' || window.automated_testing)
            },

            getOutlets(data){

                this.loading = true
                return this.app.http.get('outlets', data)
                    .then(response => {
                        this.loading = false
                        this.outlets = response.data.outlets
                        if (data.postcode){
                            this.postcode = data.postcode
                            this.search_method = 'POSTCODE'
                        } else {
                            this.postcode = null
                            this.search_method = 'GPS'
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Unable to load stores' }
                        )
                    })
            },

            getOutletsGPS(){
                return new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.location_access_granted = true
                        resolve({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        })
                    }, (error) => {
                        // Permission error
                        if (error.code == 1){
                            reject({
                                title: 'Location access unavailable',
                                message: `Please ensure that location access is enabled in your device settings
                                    and allow location access when prompted, or search by postcode.`,
                            })
                        }
                        // Other error
                        else {
                            reject({
                                title: 'Location error',
                                message: 'An error occurred while obtaining your location - please search by postcode instead.',
                            })
                        }
                    });
                })
                .then((location) => {
                    this.getOutlets(location)
                })
                .catch(error => {
                    this.$ons.notification.alert(
                        error.message,
                        { title: error.title }
                    )
                })
            },

            getOutletsPostcode(){

                const msg = 'Please enter your postcode'
                this.$ons.notification.prompt(
                        msg,
                        {
                            title: 'Find nearby stores',
                            'class': 'dlg-postcode-search',
                            autofocus: true,
                            cancelable: true,
                        }
                    )
                    .then(postcode => {
                        this.getOutlets({ postcode: postcode.toUpperCase().trim() })
                    })
            },

            sidebarToggle(){
                this.setSidebarOpen(true)
            },

            isOwnPage() {
                return this.$route.name == 'Outlets'
            },

            searchAgain(){
                this.outlets = null
                this.load_image = true
            }
        },

        computed: {

            ...mapGetters([
                'ready',
                'order',
                'basketInfo',
                'outlet',
                'user',
                'location',
                'embedClient',
                'browse_only',
            ]),

            show_loading: function(){
                return this.loading
            },

            filtered_outlets: function(){

                const query = this.outlet_query.toLowerCase().trim()

                if (query.length == 0)
                    return this.outlets

                return this.outlets.filter(outlet => {
                    return outlet.store_display_name.toLowerCase().includes(query) ||
                        outlet.tags.find(t => t.toLowerCase().includes(query))
                })
            },

            show_search_gps: function(){
                return this.canUseGPS()
            },

            postcode_search_label: function(){
                return this.search_method == 'POSTCODE' ?
                    'Try a different postcode' : 'Search by postcode'
            },

            location_string: function(){
                return this.search_method == 'GPS' ? 'your location' : this.postcode
            },
        },

        watch: {

            '$route': function(to, from){

                if (to.name == 'Outlets') {
                    const client = this.embedClient
                    if (client) {
                        this.$nextTick(() => {
                            this.$router.push(`${client}/all`)
                        })
                    }
                }

                if(this.$route.params.notify_user){
                    this.$ons.notification
                        .alert(
                                this.$route.params.notify_user[0],
                                this.$route.params.notify_user[1],
                            )
                }

                // Lookup outlets using GPS when coming back to this page only if we have permission (prevents showing
                // an error dialog for an action the user never requested)
                if (this.canUseGPS() && this.outlets == null && to.name == 'Outlets' && this.location_access_granted)
                    this.getOutletsGPS()

                // Load background image if not already loaded
                if (this.load_image == false && to.name == 'Outlets')
                    this.load_image = true
            },

            ready(is_ready){

                if (this.isOwnPage() && this.canUseGPS() && is_ready)
                    this.getOutletsGPS()
            },
        }
    }
</script>

<style scoped>
    .bottom-button-container {
        text-align: center;
    }

    .bottom-button-container .main-header {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 25px;
    }

    .bottom-button-container button:not(:last-child) {
        margin-bottom: 15px;
    }

    .content {
        height: 100%;
    }

    .outlets-list {
        height: 100%;
        overflow-y: scroll;
        background: #FFF;
        position: absolute;
        width: 100%;
    }

    .big-button-container {
        position: fixed;
        right: 0;
        bottom: 2vh;
    }

    .content {
        height: 100%;
        overflow-x: scroll;
    }

    @media (max-height: 667px) {
        .bottom-button-container .main-header {
            font-size: 22px;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .front-image {
            height: 45vh;
            object-fit: cover;
        }
    }
</style>

<style>
    @media screen and (min-width: 350px) {
        .outlet-logo {
            min-width: 76px;
        }

        .outlet-logo img {
            width: 65px;
            height: 65px;
        }
    }

    .dlg-postcode-search input.text-input {
        text-transform: uppercase;
    }

    .front-image {
        width: 100%;
        height: 50vh;
        object-fit: cover;
    }

    .logo {
        height: 100%;
        padding: 10px;
        margin: 0px auto;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/outlets/outlets.vue